var _rect, _rect2, _rect3, _rect4, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportContactBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ImportContacts_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1181",
    "data-name": "Rectangle 1181",
    width: 22,
    height: 22,
    transform: "translate(0.97 1)",
    opacity: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(0.97 1)",
    fill: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    width: 22,
    height: 22,
    transform: "translate(1 1)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    d: "M15.79,21.35A19.939,19.939,0,0,1,4.53,20.26c.07-3.64,3.39-6.57,7.47-6.57a10.6,10.6,0,0,1,3.16.58",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "arrow-up-circle",
    d: "M17.21,13.2a4.5,4.5,0,1,0,4.5,4.5,4.494,4.494,0,0,0-4.5-4.5Zm1.98,4.6a.338.338,0,0,1-.49,0l-1.14-1.13v2.89a.354.354,0,0,1-.35.35.348.348,0,0,1-.35-.35V16.67L15.72,17.8a.357.357,0,0,1-.49-.01.344.344,0,0,1,0-.48l1.73-1.72a.357.357,0,0,1,.49,0l1.73,1.72a.338.338,0,0,1,0,.49h0Z",
    fill: "#1450ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3287",
    "data-name": "Group 3287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    d: "M15.74,6.02A3.74,3.74,0,1,1,12,2.28h0a3.761,3.761,0,0,1,1.61.36",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(14.49 3.59)",
    fill: "#1450ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportContactBtnIcon);
export default __webpack_public_path__ + "static/media/import-contact-btn-icon.8bde2ca62f5c0a706c8bead4d08c87f3.svg";
export { ForwardRef as ReactComponent };